import { connect } from 'react-redux';
import { translate } from '../../../../base/i18n/functions';
import { toggleSecurityDialog } from '../../../actions';
import { SETTINGS_TOOLBOX_VISIBLE } from '../../../../toolbox/actionTypes';
import AbstractSecurityDialogButton, { _mapStateToProps as _abstractMapStateToProps } from '../AbstractSecurityDialogButton';
/**
 * Implements an {@link AbstractSecurityDialogButton} to open the security dialog.
 */
class SecurityDialogButton extends AbstractSecurityDialogButton {
    /**
     * Opens / closes the security dialog.
     *
     * @private
     * @returns {void}
     */
    _handleClickSecurityButton() {
        // const { dispatch, _locked } = this.props;        
        // dispatch(toggleLobbyMode(!_locked));
        const { dispatch } = this.props;
        dispatch(toggleSecurityDialog());
        dispatch({
            settingsVisible: false,
            type: SETTINGS_TOOLBOX_VISIBLE
        });
    }
}
export default translate(connect(_abstractMapStateToProps)(SecurityDialogButton));
